import { render } from "./TheHeading.vue?vue&type=template&id=513bdadd&scoped=true"
import script from "./TheHeading.vue?vue&type=script&lang=js"
export * from "./TheHeading.vue?vue&type=script&lang=js"

import "./TheHeading.vue?vue&type=style&index=0&id=513bdadd&lang=scss&scoped=true"

import exportComponent from "/home/developer/public_html/admin.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-513bdadd"]])

export default __exports__